function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M193.123,266.744c-11.776,0-21.333,9.557-21.333,21.333s9.557,21.333,21.333,21.333s21.333-9.557,21.333-21.333 S204.899,266.744,193.123,266.744z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M278.456,266.744c-11.776,0-21.333,9.557-21.333,21.333s9.557,21.333,21.333,21.333s21.333-9.557,21.333-21.333 S290.232,266.744,278.456,266.744z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M107.789,266.744c-11.776,0-21.333,9.557-21.333,21.333s9.557,21.333,21.333,21.333s21.333-9.557,21.333-21.333 S119.565,266.744,107.789,266.744z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M506.885,337.001c-6.513-6.513-11.672-13.908-15.628-22.083c-7.715-15.942-10.273-33.007-9.73-47.561 c20.811-26.105,31.607-54.246,31.607-85.939c0-88.441-84.11-149.333-192-149.333c-91.631,0-167.02,44.194-186.79,113.094 C56.182,163.011,1.123,216.525,1.123,288.077c0,31.711,10.796,59.857,31.607,85.943c0.542,14.553-2.016,31.616-9.73,47.556 c-3.956,8.175-9.116,15.57-15.628,22.083c-15.894,15.894,0.427,42.389,21.772,35.343c10.156-3.353,27.536-10.064,50.455-19.339 c1.812-0.734,1.812-0.734,3.621-1.468c12.108-4.918,24.86-10.181,37.472-15.444c5.119-2.136,9.449-3.952,12.747-5.34h59.685 c89.492,0,162.617-41.897,184.957-106.658h2.738c3.298,1.388,7.628,3.204,12.747,5.34c12.612,5.263,25.364,10.527,37.472,15.444 c1.809,0.734,1.809,0.734,3.621,1.468c22.919,9.275,40.299,15.987,50.455,19.339C506.457,379.39,522.779,352.895,506.885,337.001 z M193.123,394.744h-64c-2.856,0-5.683,0.573-8.313,1.686c-3.271,1.384-9.052,3.816-16.55,6.944 c-11.502,4.8-23.119,9.599-34.228,14.123c5.005-17.612,6.207-34.916,5.032-50.441c-0.144-1.908-0.302-3.364-0.434-4.321 c-0.561-4.075-2.288-7.902-4.974-11.018c-17.475-20.277-25.867-40.512-25.867-63.641c0-51.349,43.84-91.452,108.987-103.17 c0.926-0.035,1.864-0.126,2.81-0.285c12.565-2.115,25.042-3.203,37.548-3.203c46.083,0,85.348,12.787,112.033,33.974 c23.541,18.695,37.29,43.927,37.29,72.685c0,0.845-0.017,1.686-0.04,2.525c-0.164,4.558-0.764,9.338-1.816,14.733 c-0.132,0.678-0.223,1.352-0.289,2.024C328.651,358.692,270.501,394.744,193.123,394.744z M444.594,245.068 c-2.682,3.115-4.407,6.938-4.968,11.01c-0.132,0.957-0.289,2.413-0.434,4.321c-1.175,15.525,0.027,32.829,5.032,50.441 c-11.109-4.524-22.726-9.323-34.228-14.123c-7.498-3.129-13.279-5.56-16.55-6.944c-2.63-1.113-5.457-1.686-8.313-1.686 c0-42.842-19.737-79.219-52.352-105.342c-34.716-27.81-84.025-44-139.658-44c-3.414,0-6.803,0.062-10.168,0.183 c21.669-38.669,73.586-64.174,138.178-64.174c86.748,0,149.333,45.31,149.333,106.667 C470.467,204.528,462.074,224.765,444.594,245.068z"
}))));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var SvgChat = function SvgChat(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.256 512.256",
    style: {
      enableBackground: "new 0 0 512.256 512.256"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chat.d56048cd.svg";
export { ForwardRef as ReactComponent };